"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _lodash = _interopRequireDefault(require("lodash"));

var _Button = _interopRequireDefault(require("./Button"));

var _styling = require("../../toolkit/styling");

var _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* babel-plugin-inline-import '../../img/chevron-right.svg' */

/* SVGs */
var chevronRight = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgxNnYxNkgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgOCA4KSI+CiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iI0M3MzUzNSIgZmlsbC1vcGFjaXR5PSIwIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDxnIGZpbGw9IiMxNTI5MzQiIG1hc2s9InVybCgjYikiPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InNjYWxlKDEgLTEpIHJvdGF0ZSg0NSAxOS43NzggMy4xMjEpIj4KICAgICAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIxMCIgaGVpZ2h0PSIyIiByeD0iMSIvPgogICAgICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjIiIGhlaWdodD0iMTAiIHJ4PSIxIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";

var SquaredChevronButton = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SquaredChevronButton, _Component);

  var _super = _createSuper(SquaredChevronButton);

  function SquaredChevronButton() {
    (0, _classCallCheck2["default"])(this, SquaredChevronButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SquaredChevronButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          direction = _this$props.direction,
          size = _this$props.size,
          buttonProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className", "direction", "size"]);
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
        padding: "8px"
      }, buttonProps, {
        className: (0, _styling.css)(className)
      }), /*#__PURE__*/_react["default"].createElement("img", {
        className: (0, _styling.css)(this.styles.icon),
        src: chevronRight,
        alt: "arrow button",
        draggable: false
      }));
    }
  }, {
    key: "rotation",
    get: function get() {
      var direction = this.props.direction;

      switch (direction) {
        case "up":
          return "rotate(270deg)";

        case "right":
          return "rotate(0deg)";

        case "down":
          return "rotate(90deg)";

        default:
          return "rotate(180deg)";
      }
    }
  }, {
    key: "styles",
    get: function get() {
      var size = this.props.size;
      return _aphrodite.StyleSheet.create({
        icon: {
          width: size,
          height: size,
          transform: this.rotation
        }
      });
    }
  }]);
  return SquaredChevronButton;
}(_react.Component), _class3.propDoc = _objectSpread(_objectSpread({}, _lodash["default"].omit(_Button["default"].propDoc, ["text"])), {}, {
  direction: {
    required: true,
    type: "\"left\" | \"right\" | \"down\" | \"up\"",
    description: "Direction of the arrow"
  },
  size: {
    required: false,
    defaultValue: "15",
    type: "number",
    description: "Size of the button"
  }
}), _class3.demoProps = {
  onClick: function onClick() {},
  direction: "right",
  popoverContent: "Go to next page"
}, _class3.defaultProps = {
  size: 15
}, _class3.discussion = "\n    This component wraps [`Button`](/lego/component/Button).\n  ", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "rotation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "rotation"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = SquaredChevronButton;
exports["default"] = _default;